import Vue from 'vue'
import VueGtag from 'vue-gtag'
import router from '@/router'

Vue.use(VueGtag, {
  bootstrap: false
}, router)
